import { render, staticRenderFns } from "./VPrescriptionDrawingUploadSelect.vue?vue&type=template&id=28914771&"
import script from "./VPrescriptionDrawingUploadSelect.vue?vue&type=script&lang=ts&"
export * from "./VPrescriptionDrawingUploadSelect.vue?vue&type=script&lang=ts&"
import style0 from "./VPrescriptionDrawingUploadSelect.vue?vue&type=style&index=0&id=28914771&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports